import React from 'react';
import { DialogTitle, Stack, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CloseableDialogTitleProps {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    titleAlign?: 'left' | 'center' | 'right';
    icon?: React.ReactNode;
    onClose: () => void;
}

const CloseableDialogTitle: React.FC<CloseableDialogTitleProps> = ({ title, subtitle, titleAlign = 'left', icon, onClose }) => {


    const renderSubtitle = () => {
        if (subtitle) {
            if (typeof subtitle === 'string') {
                return (
                    <Typography variant='body3' color='text.secondary'>
                        {subtitle}
                    </Typography>
                );
            } else {
                return subtitle;
            }
        }
    };

    return (
        <DialogTitle
            sx={(theme) => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderBottom: `1px solid ${theme.palette.divider}`,
                marginBottom: theme.spacing(1.5),
                paddingBottom: theme.spacing(),
                paddingTop: theme.spacing(2)
            })}
        >
            <Stack  sx={{
                width: '100%',
                gap: 1
            }}>
                <Stack
                    direction='row'
                    gap={1}
                    sx={{
                        width: '100%',
                        alignItems: 'baseline',
                        justifyContent: 'space-between'
                    }}
                >
                    <Stack direction='row' gap={1}>
                        {icon && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</Box>}
                        <Box sx={{ flex: 1, textAlign: titleAlign }}>

                            {typeof title === 'string' ? (
                                <Typography variant='h2' component='div' sx={{ textAlign: titleAlign }}>
                                    {title}
                                </Typography>
                            ) : (
                                title
                            )}
                        </Box>

                    </Stack>


                    <IconButton onClick={onClose} aria-label='close' sx={(theme) => ({ alignSelf: titleAlign === 'center' ? { position: 'absolute', right: theme.spacing(0.5), top: theme.spacing(0.5) } : 'flex-start' })}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
                {renderSubtitle()}
            </Stack>


        </DialogTitle>
    );
};

export default CloseableDialogTitle;
